import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { useWindowSize } from '@yme/hooks/useWindowSize';
export function LongIntroductionSectionSkeleton() {
    const { isMobileView, isInfiniteDesktopView } = useWindowSize();
    return (React.createElement(Container, null,
        React.createElement(Row, { justifyContent: "center" },
            React.createElement(Col, { lg: 6 },
                React.createElement(Skeleton, { skeletonProps: {
                        height: isInfiniteDesktopView ? 32 : 28,
                        width: '50%',
                    } }),
                React.createElement(Skeleton, { skeletonProps: {
                        height: 16,
                        count: isMobileView ? 5 : 3,
                    }, wrapperProps: {
                        mtS: 16,
                    } }),
                React.createElement(Skeleton, { skeletonProps: {
                        height: 16,
                        count: isMobileView ? 5 : 3,
                    }, wrapperProps: {
                        mtS: 16,
                    } })))));
}
